var author_related_posts = (function( $ ) {

	var _init = function() {
		_setup_view_more_button();
	};

	var _setup_view_more_button = function() {
		$( document ).on( 'click', '.view-more-btn', function() {
			var $container = $( this ).closest( '.posts-container' );
			var $hidden_posts = $container.find( '.hidden-post' );

			if ( $( this ).text() === 'View More' ) {
				$hidden_posts.show();
				$( this ).text( 'View Less' );
			} else {
				$hidden_posts.hide();
				$( this ).text( 'View More' );
			}
		} );
	};

	$( document ).ready( function() {
		_init();
	} );

	return {};

})( jQuery );
